import { render, staticRenderFns } from "./general-setting.vue?vue&type=template&id=cc2d6be4&"
import script from "./general-setting.vue?vue&type=script&lang=js&"
export * from "./general-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports